export default __webpack_public_path__ + "static/media/vsdashboard.966b2287.webp";